import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import { defaultShouldDehydrateQuery, Query } from "@tanstack/react-query";
import type { PersistQueryClientOptions } from "@tanstack/react-query-persist-client";
import { arrayStartsWith } from "~/shared/util/arrayStartsWith";
import { USERS_KEYS } from "../users/users.queries";

const persister = createAsyncStoragePersister({
  storage: window.localStorage,
  key: "breakline-query-cache",
  throttleTime: 1000,
});

export const persistOptions: Omit<PersistQueryClientOptions, "queryClient"> = {
  persister,
  maxAge: 1000 * 60 * 60 * 24, // 24 hours
  dehydrateOptions: {
    shouldDehydrateQuery: (query) => {
      // Only persist successful queries (not pending/error states) and limit to specific query keys
      return (
        defaultShouldDehydrateQuery(query as unknown as Query) &&
        arrayStartsWith([...query.queryKey], [...USERS_KEYS.profile()])
      );
    },
  },
};
